<template>
    <PopupOrderCheckDataWindow ref="popup" />
    <div class="order-page" :class="{'container-fluid container-xl': !isShowOnlyContent}">
        <FormComponent
            formName="order"
            @response="handleFormResponse"
            @inputErrors="updateFormErrors"
            @overallCompletion="showCompletion"
            :action="sendResponseNewOrder"
            class="row g-4 g-xl-5"
        >
            <template v-slot="{ handleInputError, checkInputError }">
                <div class="">
                    <CInput
                        v-model="form.inputFio"
                        :maxPercent="8"
                        @error="handleInputError"
                        className="forminput"
                        ref="input_fio"
                        id="fio"
                        name="fio"
                        label="Фамилия, имя и отчество"
                        required
                    />
                </div>
                <div class="col-12">
                    <div class="row g-4">
                        <div class="col-12 col-md-4">
                            <CInput
                                v-model="form.inputPhone"
                                :maxPercent="8"
                                :validationFunction="tools.validatePhone"
                                :mask="tools.formatPhone"
                                @error="handleInputError"
                                className="forminput"
                                ref="input_phone"
                                id="phone"
                                name="phone"
                                label="Телефон"
                                placeholder="+7 (___) ___-__-__"
                                required
                            />
                        </div>
                        <div class="col-12 col-md-8">
                            <CInput
                                v-model="form.inputEmail"
                                :maxPercent="8"
                                :validationFunction="tools.validateEmail"
                                @error="handleInputError"
                                className="forminput"
                                ref="input_email"
                                id="email"
                                name="email"
                                label="Электронная почта"
                                placeholder="primer@medmobil.ru"
                                required
                            />
                        </div>
                    </div>
                </div>
                <div class="gender-field-row">
                    <label class="ui-form__label">Пол пациента</label>
                    <div>
                        <CheckboxGroup
                            name="gender"
                            className=""
                            :checkboxes="form.genderCheckboxes"
                            :maxSelected="1"
                            :requiredCount="1"
                            :maxPercent="8"
                            @change="handleGenderChange"
                            @error="handleInputError"
                        />
                        <div class="mt-2" style="margin-left: 175px">
                            <CheckboxGroup
                                type="checkbox"
                                v-if="form.genderCheckboxes[1].checked === true"
                                name="pregnant"
                                checkboxesClass="ui-checkbox--sm"
                                :checkboxes="form.pregnantCheckboxes"
                                :maxSelected="1"
                                :requiredCount="0"
                                @error="handleInputError"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-5 col-md-3">
                    <CInput
                        v-model="form.inputWeight"
                        :maxPercent="8"
                        :mask="tools.formatNumber(600)"
                        @error="handleInputError"
                        className="forminput"
                        ref="input_weight"
                        id="weight"
                        name="weight"
                        label="Вес пациента (кг)"
                        required
                    />
                </div>
                <div class="age-field-row">
                    <label class="ui-form__label">Возраст пациента</label>
                    <CheckboxGroup
                        name="year"
                        className=""
                        :checkboxes="form.yearsCheckboxes"
                        :maxSelected="1"
                        :requiredCount="1"
                        :maxPercent="8"
                        @error="handleInputError"
                    />
                </div>
                <div class="mobility-field-row">
                    <label class="ui-form__label">Мобильность пациента</label>
                    <CheckboxGroup
                        name="mobile"
                        className=""
                        :checkboxes="form.mobileCheckboxes"
                        :maxSelected="1"
                        :requiredCount="1"
                        :maxPercent="8"
                        @error="handleInputError"
                    />
                    <div
                        v-if="form.mobileCheckboxes[0].checked === true"
                        class="d-inline-flex align-items-center mt-2"
                        style="margin-left: 34px"
                    >
                        <CheckboxGroup
                            type="checkbox"
                            name="sitting"
                            checkboxesClass=""
                            :checkboxes="form.sittingCheckboxes"
                            :maxSelected="1"
                            :requiredCount="0"
                            @error="handleInputError"
                        />
                        <HoverIcon class="ms-2">
                            <template v-slot:hoverText>
                                Может принять сидячее положение на непродолжительное время<br />
                            </template>
                        </HoverIcon>
                    </div>
                </div>
                <div class="state-field-row">
                    <label class="ui-form__label d-inline-flex align-items-center">
                        Состояние пациента
                        <div class="ms-2">
                            <HoverIcon>
                                <template v-slot:hoverText>
                                    <span style="font-weight: 700">Удовлетворительное</span> - пациент в стабильном
                                    состоянии, сопровождение бригады врачей не требуется.<br /><br />
                                    <span style="font-weight: 700">Средней тяжести</span> - пациент в стабильном
                                    состоянии, но при транспортировке может понадобиться медицинская помощь.<br /><br />
                                    <span style="font-weight: 700">Крайне тяжелое</span> - пациент находится в
                                    критическом состоянии, транспортировка возможна только на реанимобиле в
                                    сопровождении медицинской бригады.<br />
                                </template>
                            </HoverIcon>
                        </div>
                    </label>
                    <CheckboxGroup
                        name="state"
                        checkboxesClass=""
                        :checkboxes="form.stateCheckboxes"
                        :maxSelected="1"
                        :requiredCount="1"
                        :maxPercent="8"
                        @error="handleInputError"
                    />
                </div>
                <div class="">
                    <CheckboxGroup
                        name="transport"
                        className="ui-radio-group--flat"
                        checkboxesClass="ui-radio--icon"
                        :checkboxes="form.transportCheckboxes"
                        :maxSelected="1"
                        :requiredCount="1"
                        :maxPercent="0"
                        @error="handleInputError"
                    />
                </div>
                <div class="">
                    <AddressesBox @error="handleInputError" :maxPercent="16" ref="addresses" />
                </div>
                <div class="">
                    <CheckboxGroup
                        name="address"
                        checkboxesClass=""
                        :checkboxes="form.whichWayCheckboxes"
                        :maxSelected="1"
                        :requiredCount="1"
                        :maxPercent="0"
                        @error="handleInputError"
                    />
                    <div
                        v-if="form.whichWayCheckboxes[1].checked === true"
                        class="d-flex align-items-center flex-wrap mt-2"
                        style="margin-left: 198px; gap: 8px 24px"
                    >
                        <CheckboxGroup
                            type="checkbox"
                            name="wait"
                            checkboxesClass=""
                            :checkboxes="form.waitCheckboxes"
                            :maxSelected="1"
                            :requiredCount="0"
                            :maxPercent="0"
                            @error="handleInputError"
                        />
                        <div v-if="form.waitCheckboxes[0].checked === true" class="d-inline-flex align-items-center">
                            <CInput
                                name="wait_time"
                                id="wait_time"
                                type="text"
                                class="forminput input_floor input_nopaddings"
                                v-model="form.inputWaitTime"
                                :mask="tools.formatNumber(24)"
                                @error="handleInputError"
                                placeholder="1"
                            />
                            <label style="margin-left: 5px; color: gray">(время в часах)</label>
                        </div>
                    </div>
                </div>
                <div class="">
                    <label class="ui-form__label">Когда</label>
                    <CInput
                        style="margin-top: 10px"
                        v-model="form.inputWhen"
                        :maxPercent="8"
                        @error="handleInputError"
                        className="forminput"
                        ref="input_when"
                        id="when"
                        name="when"
                        :isDatetime="true"
                        required
                    />
                </div>
                <div class="">
                    <CInput
                        :isTextarea="true"
                        v-model="form.inputComment"
                        :maxPercent="12"
                        @error="handleInputError"
                        className="forminput"
                        ref="input_comment"
                        id="comment"
                        name="comment"
                        type="textarea"
                        label="Что нам важно ещё знать"
                    />
                </div>

                <span v-if="role_value == 'Administrator' || role_value == 'Operator'">
                    <div class="" style="margin-bottom: 0px">
                        <label class="ui-form__label"
                            >Вы хотите выбрать перевозчика из списка откликнувшихся на заявку?</label
                        >
                        <CheckboxGroup
                            name="owner"
                            checkboxesClass=""
                            :checkboxes="form.ownerCheckboxes"
                            :maxSelected="1"
                            :requiredCount="1"
                            :maxPercent="0"
                            @error="handleInputError"
                        />
                    </div>
                    <div v-if="form.ownerCheckboxes[1].checked" class="">
                        <label class="ui-form__label">Поиск перевозчика по названию организации</label>
                        <HoverIcon style="padding-top: 1px">
                            <template v-slot:hoverText>
                                Введите название компании. Поиск осуществляется только среди тех организаций, которые
                                находятся в базе данных сервиса Medmobil.<br />
                            </template>
                        </HoverIcon>
                    </div>
                    <div v-if="form.ownerCheckboxes[1].checked" class="">
                        <CInput
                            :validationFunction="validateChosenCarriersName"
                            v-model="form.inputOwner"
                            ref="input_owner"
                            :maxPercent="0"
                            @error="handleInputError"
                            className="forminput"
                            id="owner"
                            name="owner"
                            label="Название компании"
                            required
                        />
                        <OrganisationSuggestion
                            v-if="form.ownerCheckboxes[1].checked"
                            ref="orgNameSuggestions"
                            :inputId="'organisation_name'"
                            :onSelected="organisationSelected"
                        />
                    </div>
                </span>

                <div class="d-flex justify-content-center">
                    <button class="ui-button ui-button--xl ui-button--secondary" type="submit" @click="checkInputError">
                        Создать заказ
                    </button>
                </div>
            </template>
        </FormComponent>
    </div>
</template>

<script>
import $ from 'jquery';
import { useCookies } from 'vue3-cookies';
import CInput from './InputComponent.vue';
import FormComponent from './FormComponent.vue';
import CheckboxGroup from './CheckboxComponent.vue';
import AddressesBox from './AddressesBox.vue';
import tools from '@/assets/js/tools.js';
import HoverIcon from './HoverInfoComponent.vue';
import PopupOrderCheckDataWindow from './PopupOrderCheckDataWindow.vue';
import OrganisationSuggestion from './OrganisationSuggestion.vue';

export default {
    name: 'OrderPage',

    el: '#order_page',

    components: {
        CInput,
        CheckboxGroup,
        FormComponent,
        AddressesBox,
        HoverIcon,
        PopupOrderCheckDataWindow,
        OrganisationSuggestion,
    },

    data() {
        return {
            form: {
                pregnantCheckboxes: [
                    { id: 'pregnant1', name: 'pregnant', value: 'true', label: 'Беременная', checked: false },
                ],
                whichWayCheckboxes: [
                    { id: 'address1', name: 'address', value: 'oneway', label: 'Только туда', checked: true },
                    { id: 'address2', name: 'address', value: 'bothways', label: 'Туда и обратно', checked: false },
                ],
                genderCheckboxes: [
                    { id: 'gender1', name: 'gender', value: 'male', label: 'Мужской', checked: false },
                    { id: 'gender2', name: 'gender', value: 'female', label: 'Женский', checked: false },
                ],
                yearsCheckboxes: [
                    { id: 'year1', name: 'year', value: 'adult', label: 'Взрослый', checked: false },
                    { id: 'year2', name: 'year', value: 'child', label: 'Ребенок (до 16 лет)', checked: false },
                ],
                sittingCheckboxes: [
                    { id: 'sitting1', name: 'sitting', value: 'true', label: 'Присаживается', checked: false },
                ],
                mobileCheckboxes: [
                    { id: 'mobile1', name: 'mobile', value: 'lying', label: 'Лежачий', checked: false },
                    { id: 'mobile2', name: 'mobile', value: 'wheelchair', label: 'На кресле-коляске', checked: false },
                    {
                        id: 'mobile3',
                        name: 'mobile',
                        value: 'moving',
                        label: 'Передвигается самостоятельно',
                        checked: false,
                    },
                ],
                stateCheckboxes: [
                    { id: 'state1', name: 'state', value: 'ok', label: 'Удовлетворительное', checked: false },
                    { id: 'state2', name: 'state', value: 'average', label: 'Средней тяжести', checked: false },
                    { id: 'state3', name: 'state', value: 'serious', label: 'Крайне тяжелое', checked: false },
                ],
                transportCheckboxes: [
                    {
                        id: 'transport1',
                        name: 'transport',
                        value: 'car',
                        imageNot: 'car/car2_grey.svg',
                        imageChecked: 'car/car2_green.svg',
                        checked: true,
                    },
                    {
                        id: 'transport2',
                        name: 'transport',
                        value: 'train',
                        imageNot: 'railway/railway2_grey.svg',
                        imageChecked: 'railway/railway2_green.svg',
                        checked: false,
                    },
                    {
                        id: 'transport3',
                        name: 'transport',
                        value: 'plane',
                        imageNot: 'airplane/airplane2_grey.svg',
                        imageChecked: 'airplane/airplane2_green.svg',
                        checked: false,
                    },
                    {
                        id: 'transport4',
                        name: 'transport',
                        value: 'ship',
                        imageNot: 'boat/boat2_grey.svg',
                        imageChecked: 'boat/boat2_green.svg',
                        checked: false,
                    },
                ],
                waitCheckboxes: [
                    { id: 'wait1', name: 'wait', value: 'true', label: 'Ожидать на месте', checked: false },
                ],
                ownerCheckboxes: [
                    { id: 'owner1', name: 'owner', value: 'responder_carrier', label: 'Да', checked: true },
                    {
                        id: 'owner2',
                        name: 'owner',
                        value: 'сhosen_carrier',
                        label: 'Нет, я хочу указать конкретного перевозчика',
                        checked: false,
                    },
                ],
                formPercent: 0,
                formStatus: [],
                inputFio: '',
                inputPhone: '',
                inputEmail: '',
                inputWeight: '',
                inputWaitTime: '',
                inputWhen: '',
                inputComment: '',
                inputOwner: '',
                correctOwner: 0,
            },
            tools: tools,
            modal: {
                header: 'Подтверждение',
                info: '',
                button: '',
                color: '#0ECCAA',
            },
            isVisiblePopup: false,
            role_value: this.getCookie('role'),
            hasMounted: false,
            isShowOnlyContent: tools.isShowOnlyContent(),
        };
    },

    setup() {
        const { cookies } = useCookies();
        return { cookies };
    },

    methods: {
        getCookie(val) {
            return this.cookies.get(val);
        },
        organisationSelected(text) {
            this.form.inputOwner = text;
            this.form.correctOwner = 2;
        },
        validateChosenCarriersName() {
            var vm = this;
            // show
            vm.$refs.orgNameSuggestions.showSuggestions(vm.form.inputOwner);
            // checked current
            $.ajax({
                type: 'GET',
                url: global.BACKEND_URL + `/get_organisation_names?start=${vm.form.inputOwner}&from=0&to=1&exact=true`,
                success: function (data) {
                    vm.form.chosenOrganisationNameExists = data.length > 0;
                },
                error: function () {},
                dataType: 'json',
                contentType: 'application/json',
            });
            vm.form.correctOwner -= 1;
            return { hasError: vm.form.correctOwner <= 0, errorMessage: '' };
        },
        getCheckedValues(arrOfCheckboxes) {
            var res = [];
            for (var checkbox of arrOfCheckboxes) {
                if (checkbox.checked) res.push(checkbox.value);
            }
            return res;
        },
        handleGenderChange(value) {
            if (value.value == 'male') {
                this.form.pregnantCheckboxes[0].checked = false;
            }
        },
        showCompletion(percent) {
            this.form.formPercent = percent;
            this.$parent.$parent.setSubHeaderPercent(true, percent);
            if (this.hasMounted) {
                this.tools.saveForm('orderForm', this.form);
                this.$refs.addresses.saveLocalStorage('orderAddresses');
            }
        },
        sendResponseNewOrder() {
            var addresses = this.$refs.addresses.addresses.map((addr) => ({
                value: tools.regAddrToString(
                    addr.suggestion.intermediate,
                    addr.suggestion.addressName,
                    addr.suggestion.label
                ),
                floor: addr.floor,
                isElevator: addr.elevatorsAvailable[0].checked,
                isCargo: addr.elevatorsType[0].checked,
                point: addr.suggestion.point,
            }));
            this.$refs.popup.showOrder({
                fio: this.form.inputFio,
                phone: this.form.inputPhone,
                email: this.form.inputEmail,
                gender: this.getCheckedValues(this.form.genderCheckboxes)[0],
                isPregnant: this.form.pregnantCheckboxes[0].checked,
                weight: this.form.inputWeight,
                isAdult: this.form.yearsCheckboxes[0].checked,
                mobility: this.getCheckedValues(this.form.mobileCheckboxes)[0],
                mobilitySit: this.form.sittingCheckboxes[0].checked,
                state: this.getCheckedValues(this.form.stateCheckboxes)[0],
                transport: this.getCheckedValues(this.form.transportCheckboxes)[0],
                addresses: addresses,
                oneWay: this.form.whichWayCheckboxes[0].checked,
                wait: this.form.waitCheckboxes[0].checked,
                waitTime: this.form.inputWaitTime,
                when: new Date(this.form.inputWhen),
                comment: this.form.inputComment,
                specificOwner: this.form.ownerCheckboxes[1].checked,
                specificOwnerName: this.form.inputOwner,
            });
            return true;
        },
        handleFormResponse(event) {
            const result = event.detail.result;
            const name = event.detail.formName;
            this.form.formStatus[name] = !result;
            return result;
        },
        updateFormErrors(data) {
            this.form.formStatus[data.formName] = !data.hasError;
        },
    },

    mounted() {
        var loadedForm = this.tools.loadForm('orderForm');
        if (loadedForm) {
            this.tools.mergeIntoObject(this.form, loadedForm);
        }
        this.$refs.addresses.loadLocalStorage('orderAddresses');
        this.hasMounted = true;
    },
};
</script>

<style lang="scss"></style>
